// Pure path helpers shared between server and client. NO imports — keeps
// this module safely importable from any context (server routes, vitest,
// browser) without pulling in signal.js / supabase / FS Access.
//
// Source of truth for filesystem-safe name generation. writeLocalNote (in
// vault-local.js) re-exports sanitizeFilename from here for back-compat;
// new code imports directly from vault-paths.

// Strip filesystem-unsafe chars and trim whitespace. Does NOT append .md —
// callers add the extension to keep this composable with non-md filenames.
// Shared between writeLocalNote (writes the file) and
// buildLedgerEntryFromNote (records its path) so paths can never drift.
//
// Pass order: visible-illegal → control → invisible bidi/ZWSP/BOM →
// Unicode normalize NFC → trim. Each Unicode-targeted pass uses \uXXXX
// escape sequences (not literal high-byte Unicode) so source stays pure
// ASCII and git renders text diffs. The control + invisible passes defend
// against bad inputs that survive visible-char inspection (Chrome FS
// Access throws "Name is not allowed" on these). NFC keeps composed
// forms consistent across platforms (decomposed Unicode from macOS
// HFS+ legacy paths, etc.).
export function sanitizeFilename(title) {
  return String(title || "")
    .replace(/[/\\?%*:|"<>]/g, "-")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[\u200B-\u200F\u202A-\u202E\u2066-\u2069\uFEFF]/g, "")
    .normalize("NFC")
    .trim();
}
